// extracted by mini-css-extract-plugin
module.exports = {"exceptionPage":"main_exceptionPage__wAsX2","title":"main_title__mr2ZL","description":"main_description__miDM_","button":"main_button__EnUGS"};